// src/components/BlocTotaux.jsx
import React from "react";

export default function BlocTotaux({
    // quand il y a une remise, on passe ces 2 props :
    sousTotalHT = null,                 // le HT AVANT remise (facultatif => cache la ligne)
    remise = null,                      // { label: "Remise (10 %)", amountHT: 14.4 } (facultatif)
    // les totaux affichés (toujours requis)
    totalHT = 0,                        // si remise : HT APRÈS remise, sinon HT normal
    tva = 0,                            // TVA calculée sur le HT choisi ci-dessus
    totalTTC = 0,                       // TTC final
}) {
    const fmt = (v) =>
        new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(v || 0)) + " €";

    return (
        <div className="no-split" style={{ marginLeft: "auto", width: 260 }}>
            <table className="w-full" style={{ borderCollapse: "collapse", fontSize: 12 }}>
                <tbody>
                    {/* ——— bloc visible UNIQUEMENT s'il y a une remise ——— */}
                    {sousTotalHT != null && remise && (
                        <>
                            <tr>
                                <td style={cellLeft}>Sous-total HT</td>
                                <td style={cellRight}>{fmt(sousTotalHT)}</td>
                            </tr>
                            <tr>
                                <td style={{ ...cellLeft, color: "#b91c1c" }}>
                                    {remise.label || "Remise"}
                                </td>
                                <td style={{ ...cellRight, color: "#b91c1c" }}>
                                    − {fmt(remise.amountHT || 0)}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ ...cellLeft, fontWeight: 600 }}>
                                    Sous-total après remise (HT)
                                </td>
                                <td style={{ ...cellRight, fontWeight: 600 }}>{fmt(totalHT)}</td>
                            </tr>
                            <tr><td colSpan={2} style={{ height: 8 }} /></tr>
                        </>
                    )}

                    {/* ——— bloc commun ——— */}
                    {!remise && (
                        <tr>
                            <td style={cellLeft}>Total HT</td>
                            <td style={cellRight}>{fmt(totalHT)}</td>
                        </tr>
                    )}
                    <tr>
                        <td style={cellLeft}>TVA</td>
                        <td style={cellRight}>{fmt(tva)}</td>
                    </tr>
                    <tr>
                        <td style={{ ...cellLeft, paddingTop: 8, borderTop: "1px solid #e5e7eb", fontWeight: 600 }}>
                            Total TTC
                        </td>
                        <td
                            style={{
                                ...cellRight,
                                paddingTop: 8,
                                borderTop: "1px solid #e5e7eb",
                                fontWeight: 700,
                            }}
                        >
                            {fmt(totalTTC)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

const base = { padding: "6px 8px", lineHeight: 1.2 };
const cellLeft = { ...base, color: "#111827" };
const cellRight = { ...base, textAlign: "right", whiteSpace: "nowrap" };
